import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { RatesComponent } from './rates';
import {NgPipesModule} from 'ngx-pipes';

@NgModule({
  declarations: [
    RatesComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    RatesComponent
  ]
})
export class RatesComponentModule {}


// WEBPACK FOOTER //
// ./src/components/rates/rates.module.ts